(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/services/services-buttons.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/services/services-buttons.js');
'use strict';

const Icon = svs.ui.ReactIcon;
const Card = svs.ui.ReactCard.Card;
const baseUrl = svs.core.data.baseUrl;
const ServiceButtons = _ref => {
  let services = _ref.services;
  return React.createElement("div", {
    className: "ticket-service-buttons"
  }, services.map(service => React.createElement(Card, {
    Component: "a",
    href: "".concat(baseUrl, "/").concat(service.anchor),
    key: service.title
  }, React.createElement("span", {
    className: "ticket-service-buttons__item"
  }, React.createElement(Icon, {
    icon: service.icon,
    size: "600"
  }), React.createElement("span", {
    className: "ticket-service-buttons__text"
  }, React.createElement("span", {
    className: "ticket-service-buttons__title"
  }, service.title), service.subTitle && React.createElement("span", {
    className: "ticket-service-buttons__description"
  }, service.subTitle))))));
};
setGlobal('svs.tickets.next.components.services.ServiceButtons', ServiceButtons);

 })(window);